class ItemViewer {
    constructor($http, $scope, $uibModal) {
        this.$http = $http;
        this.$scope = $scope;
        this.modal = $uibModal;
        this.items = [];
        this.search="";

        $scope.filterFunction = (item)=>{
            return item.Name.toLowerCase().includes(this.search.toLowerCase());
        };
    }

    load()
    {
        this.$http({
            url: "/api/items",
            method: "get"
        }).then((resp) => {
                console.log(resp);
                if (!resp.error) {
                    this.items = resp.data;
                }
            },
            (err) => {
                console.log(err);
            });
    }

    open(id)
    {
        let i = id.replace('#','');
        return this.modal.open({
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'item.html',
            controller: 'ItemInstance',
            controllerAs: '$c',
            size: 'lg',
            resolve: {
                one:
                    () => {
                        return this.$http({
                            url: "/api/items/" + i + "?html=true",
                            method: "get"
                        });
                    }
            }
        });
    }
}

ItemViewer.$inject = ['$http', '$scope', '$uibModal'];

export {ItemViewer};